import { GoodsFamily } from './installations'
import { AggregatedGoodsCategory } from './productionMethods'

export const aggregatedGoodCategoriesByGoodFamilies: Record<
  GoodsFamily,
  { isReportingEnabled: boolean; value: AggregatedGoodsCategory }[]
> = {
  [GoodsFamily.ALUMINIUM]: [
    { isReportingEnabled: true, value: AggregatedGoodsCategory.ALUMINIUM_PRODUCTS },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM }
  ],
  [GoodsFamily.CEMENT]: [
    { isReportingEnabled: true, value: AggregatedGoodsCategory.CEMENT },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.CEMENT_CLINKER },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.ALUMINOUS_CEMENT },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.CALCINED_CLAY }
  ],
  [GoodsFamily.IRONANDSTEEL]: [
    { isReportingEnabled: false, value: AggregatedGoodsCategory.CRUDE_STEEL },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.DIRECT_REDUCED_IRON },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.IRON_OR_STEEL_PRODUCTS },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.SINTERED_ORE },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.PIG_IRON },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.FE_MN },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.FE_CR },
    { isReportingEnabled: false, value: AggregatedGoodsCategory.FE_NI }
  ],
  [GoodsFamily.ELECTRICITY]: [],
  [GoodsFamily.CHEMICALS]: [],
  [GoodsFamily.FERTILIZERS]: [
    { isReportingEnabled: true, value: AggregatedGoodsCategory.NITRIC_ACID },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.AMMONIA },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.MIXED_FERTILIZERS },
    { isReportingEnabled: true, value: AggregatedGoodsCategory.UREA }
  ]
}

export function getGoodsFamilyForAggregatedCategory(category: string): GoodsFamily | undefined {
  for (const [family, entries] of Object.entries(aggregatedGoodCategoriesByGoodFamilies)) {
    if (entries.some(entry => entry.value === category)) {return family as GoodsFamily}
  }
  return undefined
}
